import { SnContentType } from '@lib/api/entities';
import { SnAvatarConfig } from '@lib/ui/avatar';
import { SnIconConfig } from '@lib/ui/icon';

import { SnSearchbarOptionClickHandler } from './searchbar-option-click-handler.type';

interface ISnSearchbarOptionLabel {
  isLabel: true;
  label: string;
}

interface ISnSearchbarConfig {
  value: string;
  label: string;
  secondaryLabel?: string;
  icon?: SnIconConfig;
  avatar?: SnAvatarConfig;
  attributes?: any;
  contentType?: SnContentType;
  click?: SnSearchbarOptionClickHandler;
}

export type SnSearchbarOptionConfig = string | ISnSearchbarConfig | ISnSearchbarOptionLabel;
